import React, { useEffect } from 'react'
import './Style.css'
import AOS from 'aos';
import 'aos/dist/aos.css';
import './Style.css'

export default function Section3() {
  useEffect(() => {
    AOS.init();
  }, [])
  return (
    <section className="section3">
      <div className="banner-content">
        <div className="s3-title">With these distinctive features, we offer students a transformative learning experience that goes beyond the ordinary.</div>
        <div className="s3-qualities">
          1000+ SUCCESSFULL <br /> STUDENTS
        </div>
      </div>
    </section>
  )
}
